export default "__VITE_ASSET__CKBbt7yD__"